import React, { useCallback, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { WodEditContent } from "../../contents/htmlContent";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
  Table,
} from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import "react-phone-number-input/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { ComonIcons } from "../../contents/commonIcons";
import Button from "../buttons/primaryButton";
import VideosLibraryPopup from "../../views/pages/gymPortion/videosLibrary/videosLibraryPopup";
import { getVideosByIds } from "../../redux/actions/api/apiAction";
import { workoutDurations, workoutTypes } from "../../utils";

export const FormFirstStep = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;

  const dispatch = useDispatch();
  const { selectedInstructionVideos } = useSelector(state => state.videosLibrary);

  const [selectedVideos, setSelectedVideos] = useState([]);
  const [showVideoLibrary, setShowVideoLibrary] = useState(false);
  const [addedInstructions, setAddedInstructions] = useState([]);
  const [editingInstructionId, setEditingInstructionId] = useState(null);

  useEffect(() => {
    if (values.instructions && values.instructions.length > 0) {
      setAddedInstructions(values.instructions);
    }
  }, [values.instructions]);

  useEffect(() => {
    if (editingInstructionId && selectedInstructionVideos && selectedInstructionVideos.length > 0) {
      setSelectedVideos(selectedInstructionVideos);
    }
  }, [selectedInstructionVideos, editingInstructionId]);

  const generateUniqueId = () => {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 1000);
    return `instruction_${timestamp}_${random}`;
  };

  const addInstruction = () => {
    const instructionText = values.instruction || "";
    
    if (!instructionText.trim()) {
      return;
    }

    const newInstruction = {
      id: generateUniqueId(),
      instruction: instructionText.trim(),
      videos: selectedVideos.map(video => video.id) // Store only video IDs
    };

    const updatedInstructions = [...addedInstructions, newInstruction];
    setAddedInstructions(updatedInstructions);
    
    setFieldValue("instructions", updatedInstructions);
    
    setSelectedVideos([]);
    setFieldValue("instruction", "");
  };

  const updateInstruction = () => {
    const instructionText = values.instruction || "";
    
    if (!instructionText.trim() || !editingInstructionId) {
      return;
    }

    const updatedInstructions = addedInstructions.map(instruction => 
      instruction.id === editingInstructionId 
        ? { 
            ...instruction, 
            instruction: instructionText.trim(), 
            videos: selectedVideos.map(video => video.id) // Store only video IDs
          }
        : instruction
    );

    setAddedInstructions(updatedInstructions);
    
    setFieldValue("instructions", updatedInstructions);
    
    setEditingInstructionId(null);
    setSelectedVideos([]);
    setFieldValue("instruction", "");
  };

  const editInstruction = async (instructionId) => {
    const instructionToEdit = addedInstructions.find(inst => inst.id === instructionId);
    if (instructionToEdit) {
      setEditingInstructionId(instructionId);
      setFieldValue("instruction", instructionToEdit.instruction);
      
      //if instruction has videos, fetch them by IDs
      if (instructionToEdit.videos && instructionToEdit.videos.length > 0) {
        try {
          await dispatch(getVideosByIds(instructionToEdit.videos));
        } catch (error) {
          console.error('Error fetching videos for instruction:', error);
          setSelectedVideos([]);
        }
      } else {
        setSelectedVideos([]);
      }
    }
  };

  const cancelEdit = () => {
    setEditingInstructionId(null);
    setSelectedVideos([]);
    setFieldValue("instruction", "");
  };

  const removeInstruction = (instructionId) => {
    const updatedInstructions = addedInstructions.filter(instruction => instruction.id !== instructionId);
    setAddedInstructions(updatedInstructions);
    
    setFieldValue("instructions", updatedInstructions);

    if (editingInstructionId === instructionId) {
      cancelEdit();
    }
  };

  const removeVideo = (videoId) => {
    const updatedVideos = selectedVideos.filter(video => video.id !== videoId);
    setSelectedVideos(updatedVideos);
  };

  const handleInstructionChange = (e) => {
    setFieldValue("instruction", e.target.value);
  };

  const openVideosLibrary = () => {
    setShowVideoLibrary(true);
  };

  const handleVideoSelection = (videos) => {
    setSelectedVideos(videos);
  };

  return (
    <div className="">
      <div className="basic-info">
        <div className="members-info-wrapper info-wrapper blk-padding-y">
          <div className="info-title">
            <Title title="Workout Info" />
          </div>
          <div className="info">
            <Row>
              <Col md={6}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="text"
                    name="name"
                    id="WOD name"
                    maxLength={50}
                    placeholder={WodEditContent.name}
                    className={`form-control ${errors.name &&
                      touched.name &&
                      "is-invalid"}`}
                  />
                  {errors.name && touched.name ? (
                    <div className="invalid-feedback">{`${errors.name}`}</div>
                  ) : null}
                  <Label for="firstname" className="">
                    {WodEditContent.name}
                  </Label>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup
                  className="custom-inputs  mb-md-0"
                  id="gender-dd-container mt-0"
                >
                  <Input
                    type="select"
                    className={`form-control ${errors.type &&
                      touched.type &&
                      "is-invalid"}`}
                    name="type"
                    value={values.type}
                    id="type"
                    placeholder={"Workout Type"}
                    style={{ left: "0 !importnat", width: "100% !important" }}
                    onChange={(e) => {
                      setFieldValue("type", e.target.value);
                    }}
                  >
                    <option value="">Select Workout Type</option>
                    {workoutTypes.map(wt => <option key={wt} value={wt}>{wt}</option>)}
                  </Input>

                  <Label for="type" className="">
                    {"Workout Type"}
                  </Label>
                  {errors.type && touched.type ? (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >{`${errors.type}`}</div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md={6} className="mt-4">
                <FormGroup
                  className="custom-inputs  mb-md-0"
                  id="gender-dd-container mt-0"
                >
                  <Input
                    type="select"
                    className={`form-control ${errors.duration &&
                      touched.duration &&
                      "is-invalid"}`}
                    name="duration"
                    value={values.duration}
                    id="duration"
                    placeholder={"Workout Type"}
                    style={{ left: "0 !importnat", width: "100% !important" }}
                    onChange={(e) => {
                      setFieldValue("duration", e.target.value);
                    }}
                  >
                    <option value="">Select Workout Duration</option>
                    {workoutDurations.map(wt => <option key={wt} value={wt}>{wt}</option>)}
                  </Input>

                  <Label for="duration" className="">
                    {"Workout Type"}
                  </Label>
                  {errors.duration && touched.duration ? (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >{`${errors.duration}`}</div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
        <div className="members-info-wrapper info-wrapper blk-padding-y bg-grey p-4 border-radius-8">
          <div className="info-title">
            <Title title="Workout Program" />
          </div>
          {/* Add/Edit Instruction */}
          <div className="info d-flex align-items-start gap-20">
            <Row style={{width: "80%"}}>
              <Col md={12}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    as="textarea"
                    name="instruction"
                    id="instruction"
                    maxLength={100000}
                    placeholder={WodEditContent.instruction}
                    className={`form-control ${errors.instructions && !values.instruction && !addedInstructions.length &&
                      "is-invalid"}`}
                    style={{height: "150px"}}
                    onChange={handleInstructionChange}
                  />
                  {errors.instructions && !values.instruction && !addedInstructions.length ? (
                    <div className="invalid-feedback d-block">{`${errors.instructions}`}</div>
                  ) : null}
                  <Label for="instruction" className="">
                    Workout Instruction
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
              {editingInstructionId ? (
                <>
                  <Button
                    value="Update Instruction"
                    onClick={updateInstruction}
                    type="button"
                  />
                  <Button
                    styleClass="btn-dark-blue-transparent"
                    value="Cancel"
                    onClick={cancelEdit}
                    type="button"
                  />
                </>
              ) : (
                <Button
                  styleClass="btn-dark-blue-transparent"
                  value="Add Instruction"
                  onClick={addInstruction}
                  type="button"
                />
              )}
            </div>
          </div>
          {/* Selected Videos */}
          {
            selectedVideos.length > 0 && 
            <div className="selected-videos-card-container">
              {
                selectedVideos.map(v => {
                  return (
                    <div key={v.id} className="selected-video-card">
                      <div className="image-section">
                        <img src={v.thumbnailUrl} alt={v.title}/>
                        <span 
                          className="card-icon c-pointer"
                          onClick={() => removeVideo(v.id)}
                        >
                          {ComonIcons.delete}
                        </span>
                      </div>
                      <div className="video-title ellipsis">
                        {v.title}
                      </div>
                    </div>
                  );
                })
              }
            </div>
          }
          {/* Select Videos */}
          <div 
            className="select-videos-button mt-3 mb-3"
            onClick={openVideosLibrary}
          >
            Select Videos
          </div>
          {/* Instructions List */}
          <div className="table-main-block">
            <div className="wod-delete-table-wrapper">
              <Table striped responsive hover className="mb-0">
                <thead>
                  <tr>
                    <th>Added Instructions</th>
                    <th>Videos</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="wod-delete-table">
                  {addedInstructions.map((instructionItem, index) => {
                    return (
                      <tr key={instructionItem.id}>
                        <td className="small">
                          <div style={{maxWidth: "300px", wordWrap: "break-word"}}>
                            {instructionItem.instruction}
                          </div>
                        </td>
                        <td className="small">
                          {instructionItem.videos && instructionItem.videos.length > 0 ? (
                            <div>
                              {instructionItem.videos.length} video{instructionItem.videos.length > 1 ? 's' : ''} selected
                            </div>
                          ) : (
                            <span style={{color: "#999"}}>No videos</span>
                          )}
                        </td>
                        <td className="text-capitalize text-right">
                          <div style={{display: "flex", gap: "10px", justifyContent: "flex-end"}}>
                            <span
                              className="c-pointer"
                              onClick={() => editInstruction(instructionItem.id)}
                            >
                              {ComonIcons.edit}
                            </span>
                            <span
                              className="c-pointer"
                              onClick={() => removeInstruction(instructionItem.id)}
                            >
                              {ComonIcons.delete}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {addedInstructions.length === 0 && (
                <div className="text-center text-uppercase add-wod-td mt-5 font-weight-bold">
                  No Instructions Added Yet
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <VideosLibraryPopup
        isOpen={showVideoLibrary}
        toggle={() => setShowVideoLibrary(false)}
        onSelectVideos={handleVideoSelection}
        selectedVideos={selectedVideos}
        title="Select Videos for Workout"
      />
    </div>
  );
};